import React, { ReactElement, SFC } from 'react';
import { connect } from 'react-redux';
import StateInterface from '../../../redux/types';
import { SortingParameters, ProductSorting } from '../../../redux/products/types';
import useListingPageUrlState from '../../../hooks/ListingPage/useListingPageUrlState';
import FilterAndSortBox from './FilterAndSortBox';

export interface FilterAndSortBoxProps {
    handleFiltersClick: (event: React.MouseEvent<HTMLDivElement>) => void;
    sorting: ProductSorting[];
}

const ConnectedFilterAndSortBox: SFC<FilterAndSortBoxProps> = ({ handleFiltersClick, sorting }): ReactElement => {
    const [{ sortingParams }, setUrlState] = useListingPageUrlState();

    const sendSortValueChange = (newSortingParams: SortingParameters) => {
        setUrlState({ sortingParams: newSortingParams }, true);
    };

    return (
        <FilterAndSortBox
            value={sortingParams}
            handleFiltersClick={handleFiltersClick}
            sorting={sorting}
            onSortValueChange={sendSortValueChange}
        />
    );
};

const mapStateToProps = (state: StateInterface): { sorting: ProductSorting[] } => ({ sorting: state.products.sorting });

export default connect(mapStateToProps)(ConnectedFilterAndSortBox);
